/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;

const { selectDesktop, isCartFetched, setCartFetched } = Slices.appSlice;
const { getCart } = Slices.cartSlice;
const { addCoupon } = Slices.offerSlice;
const { updateCustomizeItemValue } = Slices.tempCartSlice;
const { selectProductEntities } = Slices.productSlice;
const { getProfile } = Slices.profileSlice;
const { loginGuest } = Slices.authSlice;
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import FetchValues from './FetchValues';

const Header = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const isDesktop = useSelector(selectDesktop);
  const profile = useSelector((state) => state.profile);
  const cart = useSelector((state) => state.cart);
  const productsMap = useSelector(selectProductEntities);
  const isFetched = useSelector(isCartFetched);

  // eslint-disable-next-line no-unused-expressions
  React.useEffect(() => {
    if (profile?.status === 'idle') {
      dispatch(getProfile()).then((profileResp) => {
        // TODO CHECK
        // console.log(`profileResp ==> `, profileResp);
        if (!profileResp.error) {
        } else {
          dispatch(loginGuest()).then(() => {
            // window.location.reload();
            dispatch(getProfile());
          });
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.status]);
  React.useEffect(() => {
    if (profile?.status === 'succeeded' && !isFetched) {
      getCartHandler();
      dispatch(setCartFetched());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.status]);
  const getCartHandler = (profileResp) => {
    // TODO CHECK
    // console.log(profileResp);
    const data = profile?.data?.data[0];
    const cartPayload = {
      cartId: data?.cartId,
      cartUpdatedAt: data?.createdAt,
    };
    dispatch(getCart(cartPayload)).then((resp) => {
      console.log(resp);
      // TODO: FIX THIS CALL
    });
  };
  // eslint-disable-next-line no-unused-expressions
  React.useEffect(() => {
    if (profile?.status === 'succeeded' && !isFetched) {
      getCartHandler();
      dispatch(setCartFetched());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.status]);

  return (
    <React.Fragment>
      {isDesktop ? <DesktopHeader {...props} ref={ref} /> : <MobileHeader {...props} ref={ref} />}
    </React.Fragment>
  );
});

export default Header;
